export default __webpack_public_path__ + "ed727168f4d7e3db2cdf0d87a6d24593.png";